import { Component,OnInit, OnDestroy,ViewChild,ElementRef } from '@angular/core';
import {ActivatedRoute,ParamMap,Router} from '@angular/router';

import 'rxjs/add/operator/switchMap';

import {Immagine} from '../beans/immagine';
import {ImmaginiBattezzatiService} from '../services/immagini-battezzati.service';


declare var OpenSeadragon: any;


@Component({
  selector: 'dettaglio-battezzato-immagine',
  templateUrl: './dettaglio-immagine-battezzato.component.html',
  styleUrls: ['./dettaglio-immagine-battezzato.component.css']
})
export class DettaglioImmagineBattezzatoComponent implements OnInit,OnDestroy {
  
 @ViewChild('mysea', { read: ElementRef }) _vcr:ElementRef;

  immagine:Immagine;
  id:number;
  idBack: number;
  idNext: number;
  nextInt=1;
  viewer:any;

 constructor (private immaginiBattezzatiService: ImmaginiBattezzatiService,private route:ActivatedRoute,private router:Router)
  {}  

  ngOnInit():void{
  

  this.route.params.subscribe( params =>
        {this.id = params['id'];
    	this.idBack=+this.id- +this.nextInt;
    	this.idNext=+this.id+ +this.nextInt;}
    )

this.route.paramMap.switchMap((params:ParamMap)=> this.immaginiBattezzatiService.getImmagine(+params.get('id')))
  .subscribe(immagine=> {this.immagine=immagine;

  	this.viewer = OpenSeadragon({id: "openseadragon1",
        prefixUrl: "assets/openseadragon/images/",
        tileSources: `assets/libri_pyramid/pyramidBattezzati/${this.immagine._path.replace('jpg','dzi')}`
    });
  });

  
  }

   ngOnDestroy(): void{
   	console.log('Destroing...');
   	this.viewer.destroy();
   }

   next():void{
   	  this._vcr.nativeElement.innerHTML='';
   	this.router.navigate(['/dettaglioImmagineBattezzato',+this.idNext]);

   }
   back():void{
   	  this._vcr.nativeElement.innerHTML='';
   	this.router.navigate(['/dettaglioImmagineBattezzato',+this.idBack]);

   }


}


// WEBPACK FOOTER //
// /Users/paspao/workspaceForMaven/libri/libriweb/src/app/dettaglio/dettaglio-immagine-battezzato.component.ts